import axios from '@/utils/request';

let prefix = process.env.VUE_APP_API_PREFIX_2;
const baseOriginURL = process.env.VUE_APP_API_PREFIX_1 + '/product_line';

// 获取客户列表
const GetCustomerList = params => {
  return axios.get(prefix + '/customer/GetCustomerList', {
    params
  });
};

// 新增客户
const CreateCustomer = data => {
  return axios.post(prefix + '/customer/CreateCustomer', data);
};

// 修改客户
const UpdateCustomer = data => {
  return axios.put(prefix + '/customer/UpdateCustomer', data);
};

// 删除客户
const DeleteCustomer = data => {
  return axios.delete(prefix + '/customer/DeleteCustomer', data);
};

// 修改客户状态
const UpdateCustomerStatus = data => {
  return axios.put(prefix + '/customer/UpdateCustomerStatus', data);
};

// 重置客户密码
const ResetPassword = data => {
  return axios.put(prefix + '/customer/ResetPassword', data);
};

// 获取客户详情
const GetCustomerInfo = params => {
  return axios.get(prefix + '/customer/GetCustomerInfo', {
    params
  });
};

// 获取客户管理统计数据
const GetCustomerManageOverview = params => {
  return axios.get(prefix + '/customer/GetCustomerManageOverview', {
    params
  });
};

// 客户总览
const GetCustomerOverview = params => {
  return axios.get(prefix + '/customer/GetCustomerOverview', {
    params
  });
};

// 获取组织树
const GetOrgTree = params => {
  return axios.get(prefix + '/customer/GetOrgTree', {
    params
  });
};

// 获取行业树形
const GetIndustryTree = params => {
  return axios.get(prefix + '/customer/GetIndustryTree', {
    params
  });
};

// 新增第一个用户
const CreateSystemFirstUser = data => {
  return axios.post(prefix + '/CreateSystemFirstUser', data);
};

// 获取客户短信总数和已使用数量
const GetCustomerSmsInfo = params => {
  return axios.get(prefix + '/customer/GetCustomerSmsInfo', {
    params
  });
};
// 产线列表
const ProductLine = params => {
  return axios.get(baseOriginURL + '/GetProductLineList', { params });
};

export {
  GetCustomerList,
  CreateCustomer,
  UpdateCustomer,
  DeleteCustomer,
  UpdateCustomerStatus,
  ResetPassword,
  GetCustomerInfo,
  GetCustomerManageOverview,
  GetCustomerOverview,
  GetOrgTree,
  GetIndustryTree,
  CreateSystemFirstUser,
  GetCustomerSmsInfo,
  ProductLine
};
